//
// Define the breakpoints the manifest need to listen to.
//
const breakpoints = [
  'mobile',
  'phablet',
  'tablet',
  'desktop',
  'large'
];

//
// Golf translation ids
//
const golf = {
  close: 'Shared:UtilityBar:Close',
  discover: 'Sales:DiscoverNav:Heading',
  helpCenter: 'Shared:UtilityBar:SupportPhone:HelpCenter',
  home: 'PC:AppHeader:Header:Home',
  mainMenu: 'Shared:MobileNav:MainMenu',
  product: 'Sales:ProductNav:Heading',
  signin: 'Shared:UtilityBar:AccountTray:SignIn'
};

export {
  golf,
  breakpoints
};
